import { Request } from 'components/Request.jsx';
import requestErrorMessage from 'functions/requestErrorMessage';

// Rehost + Reinvite under a finished doubles match: the host starts a new
// search with the same settings and invites the old match's players to it.
// On success the finished match closes so the new search takes over; a
// refusal or failed request rejects with the reason.
export default function rehostReinvite(match) {
	return Request.post(`${siteUrl}/matchmaking/rehost_reinvite`, { match_id: match.id })
		.then((response) => {
			if(!response || !response.success) {
				return Promise.reject(requestErrorMessage(response));
			}
			// The host is already in the new search, and inviting yourself fails and
			// stops the server's invite loop before the others are invited.
			const myId = typeof myUser === 'undefined' ? null : myUser?.id;
			const invitees = (response.player_ids || []).filter((playerId) => String(playerId) !== String(myId));
			if(invitees.length && response.match_id) {
				Request.post(`${siteUrl}/chats/invite_players`, { match_id: response.match_id, player_ids: invitees });
			}
			match.closeMatch();
			if(!response.searches) {
				return response;
			}
			// Dashboard pulls in the legacy matchmaking modules; load it only here.
			return import('components/Dashboard').then(({ Dashboard }) => {
				Dashboard.performOpenSearchUpdate({ searches: response.searches });
				return response;
			});
		}, (failure) => Promise.reject(requestErrorMessage(failure)));
}
